import { StundenpensumMonat } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Bezahlung/StundenpensumMonat';
import { StundenpensumWoche } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Bezahlung/StundenpensumWoche';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { DataDisplayPlain } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function ArbeitszeitkontoFixgehalt() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;

  return (
    <div className="flex flex-col gap-y-4">
      <DataDisplayPlain
        orientation="horizontal"
        variant="text"
        label={t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.sollstunden.label',
        )}
        item={t(
          `domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.sollstunden.zusammenfassung.${data.bezahlung.arbeitszeitkonto.gehaltsempfaenger.sollstunden ? 'ja' : 'nein'}`,
        )}
      />

      {data.bezahlung.arbeitszeitkonto.gehaltsempfaenger.sollstunden &&
        data.bezahlung.arbeitszeitkonto.gehaltsempfaenger.stundenpensum ===
          'monat' && <StundenpensumMonat />}
      {data.bezahlung.arbeitszeitkonto.gehaltsempfaenger.sollstunden &&
        data.bezahlung.arbeitszeitkonto.gehaltsempfaenger.stundenpensum ===
          'woche' && <StundenpensumWoche />}
    </div>
  );
}
